import Sitemaps from "./admin/settings/Sitemaps";
// import ClinicComments from './admin/moderation/clinicComments/Page';
import AdminClinics from './admin/Clinics';
import AdminDoctors from './admin/Doctors';
import AdminNetworks from './admin/Networks';
import AdminUsers from './admin/Users';
import ModReviews from './admin/moderation/reviews/Page';
import ModReviewComments from './admin/moderation/reviewComments/Page';
import ModDirectQuestions from './admin/moderation/directQuestions/Page';
import ModClinics from './admin/moderation/Clinics';
import ModDoctors from './admin/moderation/Doctors';
import ModPromotions from './admin/moderation/promotions/Page';
import ModNews from './admin/moderation/news/Page';
import ModNewsList from './admin/moderation/news/ModList';
import ModNewsPublishedList from './admin/moderation/news/PublishedList';
import Changelog from "./admin/Changelog";
import QuestionsList from "./admin/consult/QuestionsList.vue";
import QuestionsTable from "./admin/consult/QuestionsTable.vue";

import AdminFeedbackRequests from './admin/FeedbackRequests';
import AdminSettingsCities from './admin/settings/cities/Page';
import AdminSettingsRoles from './admin/settings/Roles';
import AdminPricelists from './admin/Pricelists';
import AdminMedflex from './admin/Medflex';
import AdminTools from './admin/settings/Tools'

import Clinic from "./clinics/Clinic";
import ClinicsDirectQuestions from './clinics/DirectQuestions';
import NetworkDirectQuestions from './network/DirectQuestions';
import ClinicsDoctors from './clinics/Doctors';
import ClinicsPrinting from './clinics/Printing';
import ClinicsWidgets from './clinics/Widgets';
import ClinicsReviews from './clinics/Reviews';
import ClinicsPromotions from './clinics/Promotions';
import NetworkZapisNaPriem from './network/ZapisNaPriem.vue';
import ClinicsZapisNaPriem from './clinics/ZapisNaPriem.vue';
import ClinicsActions from './clinics/Actions';
import ClinicsUploadYandexFeed from './clinics/UploadYandexFeed';
import NetworkUploadYandexFeed from './network/UploadYandexFeed';
import NetworkActions from './network/Actions';
import NetworkPromotions from './network/Promotions';
import NetworkReviews from './network/Reviews';
import ClinicUsers from './clinics/Users';
import NetworkClinics from './network/clinics/Page';
import NetworkDoctors from './network/Doctors';
import NetworkUsers from './network/Users';
import Login from "./auth/Login";
import ResetPassword from "@pages/auth/ResetPassword";
import ServiceSettings from '@pages/admin/settings/ServiceSettings';
import Context from "./admin/Context";
import Calltracking from "./admin/orders/Calltracking";
import Calls from "./clinics/Calls";
import NetworkCalls from "./network/Calls"
import CalltrackingReports from "./admin/orders/CalltrackingReports.vue";
import Checks from './admin/competitors/Checks';
import Competitors from './admin/competitors/Competitors';
import Pricelist from './clinics/Pricelist';
import AdminConsultAnswers from "./admin/consult/Answers"
import NetworkServices from './network/Services';
import ClinicsServices from './clinics/Services';
import ClinicsLimited from './clinics/Limited';
import ClinicsLimitedZapis from './clinics/LimitedZapis';
import ClinicsLimitedUploadYandexFeed from './clinics/LimitedUploadYandexFeed';
import NetworkLimitedUploadYandexFeed from './network/LimitedUploadYandexFeed';
import ClinicsLimitedReviews from './clinics/LimitedReviews';
import ClinicsLimitedOnlineAppointments from './clinics/OnlineAppointments/Limited';
import ClinicsLimitedFeedback from './clinics/LimitedFeedback';
import ClinicsPageOnlineAppointments from './clinics/OnlineAppointments/Page';
import ClinicsTableOnlineAppointments from './clinics/OnlineAppointments/Table';
import ClinicsSettingsOnlineAppointments from './clinics/OnlineAppointments/Settings';
import NetworkSettingsOnlineAppointments from './network/OnlineAppointments/Settings';
import NetworkRecordsOnlineAppointments from './network/OnlineAppointments/Records';
import NetworkLimited from './network/Limited';
import NetworkLimitedZapis from './network/LimitedZapis';
import NetworkLimitedReviews from './network/LimitedReviews';
import NetworkLimitedOnlineAppointments from './network/OnlineAppointments/LimitedOnlineAppointments';
import NetworkOnlineAppointments from './network/OnlineAppointments/Page';
import ClinicsNews from './clinics/News';
import NetworkNews from './network/News';
import DoctorsConfirm from './admin/DoctorsConfirm';
import DoctorPaymentData from './admin/moderation/DoctorPaymentData';
import PassportDetails from './admin/moderation/passportDetails/Page.vue';
import NetworkPrinting from './network/Printing';
import NetworkWidgets from './network/Widgets';
import ClinicsPromo from './clinics/Promo';
import NetworkPromo from './network/Promo';
import Statistics from './common/Statistics';
import AdminOnlineAppointments from './admin/orders/onlineAppointments/Page';
import Notifications from './common/Notifications';
import AdminConsultWithdrawals from "./admin/consult/Withdrawals"
import AdminConsultUsers from "./admin/consult/Users"
import AdminConsultDoctorAppreciations from "./admin/consult/DoctorAppreciations"
import ClinicFeedbackSettings from "./clinics/feedback/Settings";
import ClinicFeedbackAppearanceSettings from "./clinics/feedback/AppearanceSettings";
import ClinicFeedbackRequests from "./clinics/feedback/Requests";
import ClinicFeedbackAnalytics from "./clinics/feedback/Analytics";

export const Pages = {
    'clinics-doctors': ClinicsDoctors,
    'clinics-printing': ClinicsPrinting,
    'clinics-widgets': ClinicsWidgets,
    'clinics-reviews': ClinicsReviews,
    'clinics-promotions': ClinicsPromotions,
    'clinics-actions': ClinicsActions,
    'clinics-upload-yandex-feed': ClinicsUploadYandexFeed,
    'network-upload-yandex-feed': NetworkUploadYandexFeed,
    'network-promotions': NetworkPromotions,
    'network-actions': NetworkActions,
    'network-doctors': NetworkDoctors,
    'network-reviews': NetworkReviews,
    'network-zapis-na-priem': NetworkZapisNaPriem,
    'clinics-zapis-na-priem': ClinicsZapisNaPriem,
    'clinics-direct-questions': ClinicsDirectQuestions,
    'network-direct-questions': NetworkDirectQuestions,
    'admin-pricelists': AdminPricelists,
    'admin-medflex': AdminMedflex,
    'sitemaps': Sitemaps,
    'clinic': Clinic,
    'mod-clinics': ModClinics,
    'mod-doctors': ModDoctors,
    'mod-reviews': ModReviews,
    'mod-review-comments': ModReviewComments,
    'mod-direct-questions': ModDirectQuestions,
    'mod-promotions': ModPromotions,
    'mod-news': ModNews,
    'mod-news-list': ModNewsList,
    'mod-news-published-list': ModNewsPublishedList,
    'admin-feedback-requests': AdminFeedbackRequests,
    'admin-settings-cities': AdminSettingsCities,
    'admin-settings-roles': AdminSettingsRoles,
    'admin-clinics': AdminClinics,
    'admin-doctors': AdminDoctors,
    'admin-networks': AdminNetworks,
    'admin-tools': AdminTools,
    'changelog': Changelog,
    'admin-users': AdminUsers,
    'network-clinics': NetworkClinics,
    'clinic-users': ClinicUsers,
    'network-users': NetworkUsers,
    'login': Login,
    'reset-password': ResetPassword,
    'service-settings': ServiceSettings,
    'context': Context,
    'calltracking': Calltracking,
    'calls': Calls,
    'network-calls': NetworkCalls,
    'calltracking-reports': CalltrackingReports,
    'competitor-checks': Checks,
    'competitors': Competitors,
    'clinics-pricelist': Pricelist,
    'admin-consult-answers': AdminConsultAnswers,
    'network-services': NetworkServices,
    'clinics-services': ClinicsServices,
    'clinics-limited': ClinicsLimited,
    'clinics-limited-zapis': ClinicsLimitedZapis,
    'clinics-limited-upload-yandex-feed': ClinicsLimitedUploadYandexFeed,
    'network-limited-upload-yandex-feed': NetworkLimitedUploadYandexFeed,
    'clinics-limited-reviews': ClinicsLimitedReviews,
    'clinics-limited-online-appointments': ClinicsLimitedOnlineAppointments,
    'clinics-limited-feedback': ClinicsLimitedFeedback,
    'clinics-page-online-appointments': ClinicsPageOnlineAppointments,
    'clinics-table-online-appointments': ClinicsTableOnlineAppointments,
    'clinics-settings-online-appointments': ClinicsSettingsOnlineAppointments,
    'network-settings-online-appointments': NetworkSettingsOnlineAppointments,
    'network-records-online-appointments': NetworkRecordsOnlineAppointments,
    'network-limited': NetworkLimited,
    'network-limited-zapis': NetworkLimitedZapis,
    'network-limited-reviews': NetworkLimitedReviews,
    'network-limited-online-appointments': NetworkLimitedOnlineAppointments,
    'network-online-appointments': NetworkOnlineAppointments,
    'clinics-news': ClinicsNews,
    'network-news': NetworkNews,
    'doctors-confirm': DoctorsConfirm,
    'passport-details': PassportDetails,
    'doctor-payment-data': DoctorPaymentData,
    'network-printing': NetworkPrinting,
    'network-widgets': NetworkWidgets,
    'clinics-promo': ClinicsPromo,
    'network-promo': NetworkPromo,
    'statistics': Statistics,
    'admin-questions-list': QuestionsList,
    'admin-questions-table': QuestionsTable,
    'admin-online-appointments': AdminOnlineAppointments,
    'notifications': Notifications,
    'admin-consult-withdrawals': AdminConsultWithdrawals,
    'admin-consult-users': AdminConsultUsers,
    'admin-consult-doctor-appreciations': AdminConsultDoctorAppreciations,
    'clinics-feedback-settings': ClinicFeedbackSettings,
    'clinics-feedback-appearance-settings': ClinicFeedbackAppearanceSettings,
    'clinics-feedback-requests': ClinicFeedbackRequests,
    'clinics-feedback-analytics': ClinicFeedbackAnalytics,
};
